import styled from 'styled-components';
import { ActionDivider } from '../../../UI';

type ButtonConfig = {
  label: string;
  size?: 'lg' | 'md';
  type?: 'primary' | 'secondary';
  handleClick: () => void;
  disabled?: boolean;
};

type Props = {
  label: string;
  buttonConfig: ButtonConfig | null;
  includeBottomDivider?: boolean;
  helperText?: string;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #212121;
  max-width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Button = styled.div<{ size: 'lg' | 'md'; type: 'primary' | 'secondary'; disabled?: boolean }>`
  height: ${props => (props.size === 'lg' ? '44px' : '24px')};

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 20px;
  width: 180px;

  opacity: ${props => (props.disabled ? '0.7' : '1')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  background: ${props => (props.type === 'primary' ? '#3994DE' : '#E7B07F')};

  & > span {
    font-weight: ${props => (props.size === 'lg' ? '700' : '500')};
    font-size: ${props => (props.size === 'lg' ? '16px' : '12px')};
    line-height: 100%;
    color: #fff;
  }

  @media (max-width: 1024px) {
    width: 160px;
  }
`;

export const ActionRow = ({ label, buttonConfig, includeBottomDivider = true }: Props) => {
  return (
    <>
      <Wrapper>
        <Label>{label}</Label>
        {buttonConfig && (
          <Button
            size={buttonConfig.size || 'lg'}
            type={buttonConfig.type || 'primary'}
            onClick={buttonConfig.handleClick}
            disabled={buttonConfig.disabled}
          >
            <span>{buttonConfig.label}</span>
          </Button>
        )}
      </Wrapper>
      {includeBottomDivider && <ActionDivider />}
    </>
  );
};
